import React, { Component } from "react";
import Input from "../../components/Input";
import ReactRating from "react-rating";
import { FaRegStar, FaStar, FaStarHalfAlt, FaTimes } from "react-icons/fa";
import Select from "react-select";
import { observer } from "mobx-react";
import voiceStore from "../../stores/voiceStore";
import generalStore from "../../stores/generalStore";

const UpdateTalentDetailsModal = observer(
  class UpdateTalentDetailsModal extends Component {
    constructor(props) {
      super(props);
      this.state = {
        TalentName: "",
        MobileNo: "",
        Email: "",
        Age: "",
        SocialAccounts: "",
        Nationality: "",
        Accents: [],
        Notes: "",
        Rating: 0,
        Fee: "",
        ProfileImgPath: null,
        ProfileImgUrl: null,
        tempImageUrl: null,
      };
    }

    handleAccentsSelect = (data) => {
      this.setState({ Accents: data });
    };

    handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = 400;
          canvas.height = 400;

          ctx.drawImage(img, 0, 0, 400, 400);

          canvas.toBlob((blob) => {
            const newFile = new File(
              [blob],
              `${file.lastModified}-${Math.floor(
                Math.random() * 99999
              )}.${file.name.split(".").pop()}`,
              {
                type: file.type,
                lastModified: file.lastModified,
              }
            );
            this.setState({
              ProfileImgPath: newFile,
              tempImageUrl: URL.createObjectURL(newFile), // Use the blob URL for preview
            });
          }, file.type);
        };
      }
    };

    componentDidMount() {
      this.setState({ ...voiceStore.talent });
      this.setState({ ProfileImgUrl : voiceStore.talent.ProfileImgPath });
      setTimeout(() => {
        if (this.state.SocialAccounts) {
          try {
            const formattedSocialAccounts = JSON.parse(
              this.state.SocialAccounts
            );
            this.setState({ SocialAccounts: formattedSocialAccounts });
          } catch (e) {
            return false;
          }
        }
      }, 500);

      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        voiceStore.setUpdateTalentDetailsModalVisible(false);
      }
    };

    formatAccentsForSelect = () => {
      if (typeof this.state.Accents == "string" && this.state.Accents !== "") {
        const accentsArray = this.state.Accents.split(",").map((accent) =>
          accent.trim()
        );
        let formattedAccents = accentsArray.map((accent) => ({
          label: accent,
          value: accent,
        }));

        return formattedAccents;
      }
    };

    validateFields = () => {
      const { TalentName } = this.state;

      return TalentName.trim() !== "";
    };

    render() {
      const {
        TalentName,
        MobileNo,
        Email,
        Age,
        SocialAccounts,
        Nationality,
        Notes,
        Rating,
        Fee,
        ProfileImgPath,
        tempImageUrl,
      } = this.state;

      const accentsOptions = voiceStore.dropdownData.accentOptions;

      return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 z-[52]">
          <div className="flex relative flex-col overflow-scroll w-full lg:w-1/2 h-full lg:h-[85%] py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">
            <div className="flex flex-col z-50">
              <span className="font-normal text-lg text-[#21272A] my-6">
                Profile Photo
              </span>
              <div className="flex flex-1 flex-row">
                <div className="flex flex-row items-center gap-6">
                  {tempImageUrl ? (
                    <img
                      src={tempImageUrl}
                      className="w-[100px] h-[100px] rounded-full"
                      alt="Profile"
                    />
                  ) : ProfileImgPath ? (
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL + "/" + ProfileImgPath
                      }
                      className="w-[100px] h-[100px] rounded-full"
                      alt="Profile"
                    />
                  ) : (
                    <div className="w-[100px] h-[100px] rounded-full bg-gray-200 flex justify-center items-center text-2xl text-black/50">
                      {generalStore.getInitials(TalentName)}
                    </div>
                  )}
                  <div className="flex flex-col justify-center items-center">
                    <button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      className="border-[2px] px-4 py-2 border-[#000000] text-base font-normal text-[#000000]"
                    >
                      Upload Photo
                    </button>
                    <input
                      id="fileInput"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={this.handleFileChange}
                    />
                    <button
                      onClick={() =>
                        this.setState({
                          ProfileImgPath: null,
                          tempImageUrl: null,
                          ProfileImgUrl: null
                        })
                      }
                      className="text-base font-normal text-[#000000] mt-2"
                    >
                      remove
                    </button>
                  </div>
                </div>
                <div className="w-[1px] h-full bg-[#DDE1E6] mx-12 hidden lg:flex"></div>
                <div className="flex-1 flex-col hidden lg:flex">
                  <span className="text-lg font-normal text-[#21272A]">
                    Image requirements:
                  </span>
                  <span className="text-sm font-normal text-[#21272A] mt-2">
                    - Your face or company logo
                  </span>
                </div>
              </div>

              <div className="h-[1px] w-full bg-[#DDE1E6] mt-6"></div>
              <span className="font-normal text-lg text-[#21272A] my-6">
                Talent Details
              </span>

              <div className="flex flex-col lg:flex-row gap-4 mt-4">
                <Input
                  title="Talent Name"
                  onChange={(e) =>
                    this.setState({ TalentName: e.target.value })
                  }
                  value={TalentName}
                />
              </div>

              <div className="flex flex-col lg:flex-row gap-4 mt-4">
                <Input
                  type="tel"
                  title="Phone Number"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  maxLength={13}
                  onChange={(e) => this.setState({ MobileNo: e.target.value })}
                  value={MobileNo}
                />
                <Input
                  type="email"
                  title="E-mail"
                  onChange={(e) => this.setState({ Email: e.target.value })}
                  value={Email}
                />
              </div>

              <div className="flex flex-col lg:flex-row gap-4 mt-4">
                <div className="flex flex-1 flex-col justify-center">
                  <Input
                    title="Birthday"
                    onChange={(e) => this.setState({ Age: e.target.value })}
                    type="date"
                    value={Age}
                  />
                </div>

                <Input
                  title="Social Accounts"
                  onChange={(e) =>
                    this.setState({ SocialAccounts: e.target.value })
                  }
                  value={SocialAccounts}
                />
              </div>

              <div className="flex flex-col lg:flex-row gap-4 mt-4">
                <Input
                  title="Nationality"
                  onChange={(e) =>
                    this.setState({ Nationality: e.target.value })
                  }
                  value={Nationality}
                />
                <div className="flex flex-1 flex-col justify-center">
                  <span className="text-sm font-normal text-[#21272A]">
                    Accents
                  </span>
                  <Select
                    options={accentsOptions}
                    placeholder="Select..."
                    value={this.formatAccentsForSelect()}
                    onChange={this.handleAccentsSelect}
                    isSearchable={true}
                    isMulti
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "#F0EFEF",
                        paddingTop: 5,
                        paddingBottom: 5,
                        boxShadow: "none",
                        border: "1px solid #ccc",
                        "&:hover": {
                          border: "1px solid #ccc",
                        },
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                  />
                </div>
              </div>

              <div className="flex flex-1 flex-col lg:flex-row gap-4 mt-4">
                <div className="flex flex-1">
                  <Input
                    title="Fee"
                    onChange={(e) => this.setState({ Fee: e.target.value })}
                    value={Fee}
                  />
                </div>

                <div className="flex flex-1 flex-col justify-center">
                  <span className="text-sm font-normal text-[#21272A] my-2">
                    Rating
                  </span>
                  <ReactRating
                    emptySymbol={<FaRegStar size={24} />}
                    fullSymbol={<FaStar size={24} />}
                    halfSymbol={<FaStarHalfAlt size={24} />}
                    fractions={2}
                    onChange={(rate) => this.setState({ Rating: rate })}
                    initialRating={Rating}
                  />
                </div>
              </div>

              <Input
                type="textarea"
                title="Notes"
                onChange={(e) => this.setState({ Notes: e.target.value })}
                value={Notes}
              />

              <div className="mt-14 flex justify-end gap-2">
                <button
                  disabled={!this.validateFields()}
                  className={`text-white font-medium text-base px-6 py-2 rounded-md ${
                    this.validateFields() ? "bg-[#130D0D]" : "bg-gray-400"
                  }`}
                  onClick={() => {
                    voiceStore
                      .updateTalentDetails(this.state)
                      .then((talent) => {
                        voiceStore.setUpdateTalentDetailsModalVisible(false);
                        voiceStore.setTalentDetailsModalVisible(true);
                      });
                  }}
                >
                  Update
                </button>
              </div>

              <button
                onClick={() =>
                  voiceStore.setUpdateTalentDetailsModalVisible(false)
                }
                className="absolute top-0 right-0 mt-4 mr-4"
              >
                <FaTimes />
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
);

export default UpdateTalentDetailsModal;
